// @flow
import 'babel-polyfill';
import { isCancel } from 'axios';
import { Collection, Search, SearchableCollection } from './clients';
import Filter from './filter';

/**
 * Active version of Crisp
 * @name Version
 * @example
 * console.log(Crisp.Version);
 * // 0.0.0
 */

// This is populated by rollup
/* eslint-disable no-undef */
// $flow-ignore
const Version = __VERSION__;
/* eslint-enable no-undef */

/**
 * A function to determine if an error is due to cancellation
 * @name isCancel
 * @kind function
 * @param {error} error
 * @return {boolean}
 * @example
 * const cancelled = Crisp.isCancel(error);
 */

export { Collection, Search, SearchableCollection, Filter, isCancel, Version };
